var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cart"},[(_vm.product.region === 'ru')?_c('CartRu'):_c('Cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }